import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ShieldCheck } from 'lucide-react'
import { Logo } from '@/components/generals/logo'

import { footerColumns } from '@/constants/site'

export const Footer: FC = (): ReactNode => {
    return (
        <footer data-header-theme='dark' className='mt-auto bg-night text-night-ink'>
            <div className='border-t border-dashed border-night-line'>
                <div className='container-page grid gap-12 py-16 sm:py-20 md:grid-cols-[minmax(0,1.4fr)_minmax(0,2fr)]'>
                    <div className='flex flex-col justify-between gap-10'>
                        <div className='flex flex-col gap-4'>
                            <Link href='/' aria-label='Forge home' className='w-fit text-night-ink transition-colors duration-150 ease-out hover:text-white'>
                                <Logo className='text-night-ink' />
                            </Link>

                            <p className='max-w-xs font-heading text-[1.3rem] leading-snug text-night-ink'>
                                The autonomous engineer for production.
                            </p>
                        </div>

                        <p className='inline-flex w-fit items-center gap-2.5 rounded-full bg-white/[0.05] px-3.5 py-2 text-[13px] text-night-muted'>
                            <span className='live-dot text-healthy' aria-hidden='true' />
                            All systems operational
                        </p>
                    </div>

                    <nav aria-label='Footer' className='grid grid-cols-2 gap-10 sm:grid-cols-3'>
                        {footerColumns.map((column) => (
                            <div key={column.title} className='flex flex-col gap-4'>
                                <h2 className='font-mono text-[11.5px] uppercase tracking-[0.08em] text-night-subtle'>
                                    {column.title}
                                </h2>

                                <ul className='flex flex-col gap-3'>
                                    {column.links.map((link) => (
                                        <li key={link.href}>
                                            <Link
                                                href={link.href}
                                                className='text-[15px] text-night-muted transition-colors duration-150 ease-out hover:text-white'
                                            >
                                                {link.label}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </nav>
                </div>

                <div className='border-t border-dashed border-night-line'>
                    <div className='container-page flex flex-col gap-3 py-6 text-[13px] text-night-subtle sm:flex-row sm:items-center sm:justify-between'>
                        <p className='flex items-center gap-2'>
                            <ShieldCheck className='size-4' aria-hidden='true' />
                            SOC 2 Type II, GDPR and HIPAA ready.
                        </p>

                        <p>
                            © 2026 Forge Systems, Inc. Built in Toronto.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    )
}
